<template>
    <div>
		<!-- filter -->
		<v-row align="center" dense class="mt-0 mb-1">
			<!-- date -->
			<v-col cols="2">
				<bee-date-picker
					v-model="filterData.fromDate"
					input-label="من"
					:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
					:months-over-max="5"
					menu-picker
					calendar
					no-title
					hide-details
				></bee-date-picker>
			</v-col>
			<v-col cols="2">
				<bee-date-picker
				v-model="filterData.toDate"
				input-label="إلى"
				:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
				:months-over-max="5"
				menu-picker
				calendar
				no-title
				hide-details></bee-date-picker>
			</v-col>
			<!-- sectionId -->
			<v-col lg="2" md="3" cols="6">
				<v-autocomplete
					v-model="filterData.sectionId"
					:label="$T('inputs.section-name')"
					:items="sections"
					item-text="name"
					item-value="id"
					dense
					outlined
					hide-details
				/>
			</v-col>

			<!-- jobDescriptionId -->
			<v-col lg="2" md="3" cols="6">
				<v-autocomplete
					v-model="filterData.jobDescriptionId"
					:label="$T('inputs.employee-position')"
					:items="positions"
					item-text="name"
					item-value="id"
					dense
					outlined
					hide-details
				/>
			</v-col>

			<!-- search -->
			<v-col cols="auto">
				<v-btn
					class="me-1"
					outlined
					small
					color="primary"
					:disabled="loading"
					@click="filter()"
				>
					<v-icon small left>mdi-magnify</v-icon>
					{{ $T('default-buttons.search') }}
				</v-btn>
			</v-col>

			<v-spacer/>

			<!-- calculate employees -->
			<v-col cols="auto" class="mx-2">
				<v-btn small color="primary" :loading="submitLoading" @click="dialog = true">
					<v-icon size="20" class="me-1">mdi-cash-multiple</v-icon>
					<!-- {{ $T('calculate-salaries-for-selected-month') }} -->
					احتساب رواتب الشهر
				</v-btn>
			</v-col>

			<!-- export excel -->
			<v-col v-if="0" cols="auto">
				<v-btn
					small
					color="secondary"
					:loading="exportExcelLoading"
					@click="exportExcel"
				>
					<v-icon size="20" class="me-1">mdi-file-table-outline</v-icon>
					{{ $T("exportToExcel") }}
				</v-btn>
			</v-col>

			<v-col v-if="0" cols="auto">
				<v-btn
					small
					color="primary"
					:to="{
						name: 'add-salaries',
						query: { name: new Date().toISOString().slice(0, 10) },
					}"
				>
					<v-icon left> $add </v-icon>
					{{ $T("addSalary") }}
				</v-btn>
			</v-col>
		</v-row>

        <!-- table -->
		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="[]"
			:data-table-props="{ disableSort: true }"
			:items-per-page="20"
			:loading="loading"
			pagination-on-scroll
			pagination-on-scroll-server-items
			:server-items-length="totalItemsLength"
			dense
			zebra
			fixed-header
			:height="$vuetify.breakpoint.height - 110"
			:shown-rows-text="$T('shown-rows-text')"
			@pagination-on-scroll:reach-last-row="filter"
		>
			<template v-slot:item.actions="{ item }">
				<tooltip :text="$T('tooltips.info')">
					<v-btn small icon>
						<v-icon
							size="20"
							color="info"
							@click="employeeId = item.employeeId; detailsDialog = true;"
						>$info</v-icon>
					</v-btn>
				</tooltip>
			</template>
		</bee-handy-table>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
export default {
    data () {
        return {
			loading: false,
			filterData: {
				searchDate: new Date().toISOString().slice(0, 7),
				sectionId: null,
				fromDate: moment(this.moment().startOf('month')).format('YYYY-MM-DD'),
				toDate: moment(this.moment()).format('YYYY-MM-DD'),
				jobDescriptionId: null
			},
        }
    },
    computed: {
		...mapState({
			sections: state => state.section.sections,
			positions: state => state.positions.positions
		}),
        headers() {
			return [
				{
					text: this.$t('headers.employee-name'),
					name: 'employeeName',
					value: ''
				},
				{
					text: this.$T('headers.position-name'),
					name: 'jopDescription',
					value: 'employee.jobDescriptionId',
					setValueExpr: val => this.getPositionById(val)?.name ?? '-',
				},
				{
					text: this.$T('headers.section-name'),
					name: 'sectionName',
					value: 'employee.sectionName'
				},
				{
					text: this.$T('headers.salary-paid'),
					name: '',
					value: '',
				},
				{
					text: this.$T('headers.salary-deducted-due-to-absence'),
					name: '',
					value: ''
				},
				{
					text: this.$T('headers.additional-salary'),
					name: '',
					value: ''
				},
				{
					text: '',
					name: 'actions',
					value: 'actions'
				}
			];
		},
    },
	methods: {
		moment,
		filter () {
			this.loading = true
			this.$store.dispatch('salaries/fetchSalary', { 
				from: this.filterData.fromDate,
				to: this.filterData.toDate,
				jobDescription: this.filterData.jobDescriptionId,
				sectionId: this.filterData.sectionId
			}).finally(() => {
				this.loading = false
			})
		}
	},
	created () {
		// this.loading = true
		// this.$store.dispatch('salaries/fetchSalary', { 
		// 	from: this.filterData.fromDate,
		// 	to: this.filterData.toDate,
		// 	jobDescription: this.filterData.jobDescriptionId,
		// 	sectionId: this.filterData.sectionId
		// }).finally(() => {
		// 	this.loading = false
		// })
	}
}
</script>
